// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3-wve","title":"Info_title__1b_Gy","selects":"Info_selects__1vYqa","requiredAsterisk":"Info_requiredAsterisk__1cIKl"};